import Modal, { ModalHeader, ModalContent } from 'components/Modal';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ImageBox = styled.div`
  max-width: 400px;
  height: 400px;
  padding: 20px;

  & > img {
    width: 100%;
    height: 100%;
  }
`;

const Loading = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 40px;
    height: 40px;
    border: 6px solid ${(props) => props.theme.ui.loader.trackColor};
    border-top: 6px solid ${(props) => props.theme.ui.loader.thumbColor};
    border-radius: 100%;
    animation: rotate 1.2s ease-in-out infinite forwards;
    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

interface PreviewImageModalProps {
  title: string;
  image?: any;
  onClose: () => void;
}

const PreviewImageModal = ({ title, image, onClose }: PreviewImageModalProps) => {
  return (
    <Modal maxWidth={400}>
      <ModalHeader onCloseClick={onClose}>{title} 미리보기</ModalHeader>
      <ModalContent>
        <ImageWrapper>
          <ImageBox>
            {image ? (
              <img src={image} alt="preview" />
            ) : (
              <Loading>
                <div></div>
              </Loading>
            )}
          </ImageBox>
        </ImageWrapper>
      </ModalContent>
    </Modal>
  );
};

export default PreviewImageModal;
